import { Grid } from '@chakra-ui/react'
import { useTrail } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import { AnimatedBox, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

import IconText from './IconText'

import { IconTextProps } from '../../types'

interface Props {
  items: IconTextProps[]
}

function IconTextList({ items }: Props): React.ReactElement {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const springs = useTrail(items.length, {
    to: {
      transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
      opacity: inView ? 1 : 0,
    },
    config: DEFAULT_SPRING_CONFIG,
  })

  return (
    <Grid
      ref={ref}
      sx={{
        gridGap: { base: 6, sm: 8 },
        gridTemplateColumns: { base: '1fr', sm: 'repeat(2, 1fr)' },
      }}
    >
      {items.map((item, index) => (
        <AnimatedBox key={`${index}`} style={springs[index]}>
          <IconText {...item} />
        </AnimatedBox>
      ))}
    </Grid>
  )
}

export default IconTextList
